const BANK_DETAIL_KEYS = ["account_name", "bank_name", "sort_code", "account_number"];

export function emptyBankDetails() {
  return { account_name: "", bank_name: "", sort_code: "", account_number: "" };
}

function digitsOnly(value) {
  return String(value || "").replace(/\D/g, "");
}

export function formatSortCode(value) {
  const digits = digitsOnly(value).slice(0, 6);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}-${digits.slice(2)}`;
  return `${digits.slice(0, 2)}-${digits.slice(2, 4)}-${digits.slice(4)}`;
}

export function bankDetailsFromSupplier(supplier = {}) {
  return {
    account_name: supplier.account_name || "",
    bank_name: supplier.bank_name || "",
    sort_code: formatSortCode(supplier.sort_code || ""),
    account_number: digitsOnly(supplier.account_number).slice(0, 8),
  };
}

export function bankDetailsForApi(form) {
  const accountNumber = digitsOnly(form?.account_number).slice(0, 8);
  const sortDigits = digitsOnly(form?.sort_code).slice(0, 6);
  return {
    account_name: (form?.account_name || "").trim(),
    bank_name: (form?.bank_name || "").trim(),
    sort_code: sortDigits ? formatSortCode(sortDigits) : "",
    account_number: accountNumber,
  };
}

export function hasBankDetails(details) {
  return BANK_DETAIL_KEYS.some((key) => String(details?.[key] || "").trim());
}

export function validateBankDetails(form) {
  const details = bankDetailsForApi(form);
  if (!hasBankDetails(details)) return "";
  if (!details.account_name || !details.sort_code || !details.account_number) {
    return "Account name, sort code, and account number are all required to record where this supplier is paid.";
  }
  if (digitsOnly(details.sort_code).length !== 6) return "Sort code must be 6 digits.";
  if (details.account_number.length !== 8) return "Account number must be 8 digits.";
  return "";
}

export function responseIncludesBankDetails(data) {
  return Boolean(data) && BANK_DETAIL_KEYS.every((key) => Object.prototype.hasOwnProperty.call(data, key));
}

export function bankDetailsWereStored(responseData, sent, previous = {}) {
  if (responseIncludesBankDetails(responseData)) return true;
  return !hasBankDetails(sent) && !hasBankDetails(bankDetailsFromSupplier(previous));
}

export function paymentAccountSummary(supplier) {
  const accountNumber = digitsOnly(supplier?.account_number);
  if (!accountNumber) return "Not recorded";
  const name = (supplier.account_name || "").trim();
  const sortCode = formatSortCode(supplier.sort_code || "");
  return [name, sortCode, `••••${accountNumber.slice(-4)}`].filter(Boolean).join(" · ");
}
